/**
 * 文章分类列表
 */
import Layout from '../../pages/layout/Frame';

const articleCategoryRouter = {
    path: "/article/category",
    component: Layout,
    meta: {title: '文章管理'},
    name: "article_category_list",
    children: [
        {
            path: "/article/category/index",
            component: () => import('../../pages/article/category/Index.vue'),
            meta: {title: '文章分类',},
            name: 'article_category_list',
        },
        // {
        //     path: "/article/category/create",
        //     component: () => import('../../pages/article/category/Create.vue'),
        //     meta: {title: '文章分类',},
        //     name: 'article_category_list',
        // },
        // {
        //     path: "/article/category/edit",
        //     component: () => import('../../pages/article/category/Edit.vue'),
        //     meta: {title: '文章分类',},
        //     name: 'article_category_list',
        // },
    ]
};

export default articleCategoryRouter
